import type { CoachChatContextType } from "@/hooks/useCoachChat";
import {
  serializeCoachVeeraContextualEntry,
  type CoachVeeraContextualEntry,
} from "@/lib/coachVeeraContextualEntry";
import {
  serializeLeaderVeeraContextualEntry,
  type LeaderVeeraContextualEntry,
} from "@/lib/leaderVeeraContextualEntry";

type QueryValue = string | number | boolean | null | undefined;

function appendQueryValue(params: URLSearchParams, key: string, value: QueryValue) {
  if (value === null || value === undefined) return;
  const normalized = String(value).trim();
  if (!normalized) return;
  params.set(key, normalized);
}

export function buildLeaderVeeraRoute(params: {
  source?: string | null;
  from?: string | null;
  meetingId?: string | null;
  transcriptId?: string | null;
  day?: string | null;
  prompt?: string | null;
  contextualEntry?: LeaderVeeraContextualEntry | null;
} = {}) {
  const search = new URLSearchParams();
  appendQueryValue(search, "source", params.source);
  appendQueryValue(search, "from", params.from);
  appendQueryValue(search, "meetingId", params.meetingId);
  appendQueryValue(search, "transcriptId", params.transcriptId);
  appendQueryValue(search, "day", params.day);
  appendQueryValue(search, "prompt", params.prompt);
  if (params.contextualEntry) {
    appendQueryValue(search, "contextualEntry", serializeLeaderVeeraContextualEntry(params.contextualEntry));
  }
  const query = search.toString();
  return query ? `/veera?${query}` : "/veera";
}

export function buildCoachVeeraRoute(params: {
  leaderId?: string | null;
  action?: string | null;
  signalType?: string | null;
  signalLevel?: string | null;
  signals?: string[] | null;
  source?: string | null;
  from?: string | null;
  prompt?: string | null;
  transcriptId?: string | null;
  provenanceId?: string | null;
  contextType?: CoachChatContextType | null;
  contextualEntry?: CoachVeeraContextualEntry | null;
} = {}) {
  const search = new URLSearchParams();
  appendQueryValue(search, "action", params.action);
  appendQueryValue(search, "signalType", params.signalType);
  appendQueryValue(search, "signalLevel", params.signalLevel);
  appendQueryValue(search, "leaderId", params.leaderId);
  if (params.signals && params.signals.length > 0) {
    appendQueryValue(search, "signals", params.signals.join("|"));
  }
  appendQueryValue(search, "source", params.source);
  appendQueryValue(search, "from", params.from);
  appendQueryValue(search, "prompt", params.prompt);
  appendQueryValue(search, "transcriptId", params.transcriptId);
  appendQueryValue(search, "provenanceId", params.provenanceId);
  appendQueryValue(search, "contextType", params.contextType);
  if (params.contextualEntry) {
    appendQueryValue(search, "contextualEntry", serializeCoachVeeraContextualEntry(params.contextualEntry));
  }
  const query = search.toString();
  return query ? `/coach/veera?${query}` : "/coach/veera";
}
